import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.515 19.505a.75.75 0 1 0-1.502 0 .75.75 0 0 0 1.502 0m1.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M17.519 19.505a.75.75 0 1 0-1.502 0 .75.75 0 0 0 1.502 0m1.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M3.457 2.26a1.75 1.75 0 0 1 1.714 1.352l.387 1.656h13.76a1.75 1.75 0 0 1 1.707 2.13l-1.553 6.992a1.75 1.75 0 0 1-1.71 1.371H7.86a1.75 1.75 0 0 1-1.703-1.351l-.864-3.691-.01-.034-1.05-4.496-.003-.014-.52-2.223a.25.25 0 0 0-.244-.192l-1.894.01a.75.75 0 0 1-.008-1.5zm4.16 11.808a.25.25 0 0 0 .243.193h9.903a.25.25 0 0 0 .244-.196l1.554-6.992a.25.25 0 0 0-.244-.305H5.91z"
  }));
}
var IcCart = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCart));

export { IcCart as I };
